/* eslint-disable import/no-relative-packages */
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CableOutlinedIcon from '@mui/icons-material/CableOutlined';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import DataObjectOutlinedIcon from '@mui/icons-material/DataObjectOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DynamicFeedOutlinedIcon from '@mui/icons-material/DynamicFeedOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FlashOnOutlinedIcon from '@mui/icons-material/FlashOnOutlined';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HttpOutlinedIcon from '@mui/icons-material/HttpOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import JoinFullOutlinedIcon from '@mui/icons-material/JoinFullOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import MergeTypeOutlinedIcon from '@mui/icons-material/MergeTypeOutlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import PrecisionManufacturingOutlinedIcon from '@mui/icons-material/PrecisionManufacturingOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import QueueOutlinedIcon from '@mui/icons-material/QueueOutlined';
import SchemaOutlinedIcon from '@mui/icons-material/SchemaOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import TerminalOutlinedIcon from '@mui/icons-material/TerminalOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import TransformOutlinedIcon from '@mui/icons-material/TransformOutlined';
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import TryOutlinedIcon from '@mui/icons-material/TryOutlined';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import WebhookOutlinedIcon from '@mui/icons-material/WebhookOutlined';
import v2ExecutorTypeMap from '../../../../packages/builder-schema/v2-executor-type-map.json';
import generatedContracts from '../../../../packages/extension-kit/generated/studio-runtime-contracts.generated.json';

/** Palette metadata (title, group, color, status) per core type — generated from `core-node-metadata.source.json`. */
const NODE_METADATA = generatedContracts?.nodeMetadata || {};

/** Python executor `type` for a Studio canonical `type` (see `server/controllers/v2/v2Execution.adapter.js`). */
export function mapV2TypeToExecutorType(v2Type) {
  return v2ExecutorTypeMap[v2Type] || v2Type;
}

/** No provider/model: new AI steps follow the workspace default model chosen on the server. */
const LLM_DEFAULTS = {
  temperature: 0.3,
  maxTokens: 1024,
  systemPrompt: 'You are a helpful assistant.',
  /** When true, prepend `input.chatHistory` (from app/dashboard) before the current user message. */
  includeChatHistory: false,
  chatHistoryMaxMessages: 20,
};
const API_DEFAULTS = {
  method: 'GET',
  url: 'https://api.example.com/data',
  headers: {},
  body: '',
  timeout: 15000,
  retries: 2,
};
const CODE_DEFAULTS = {
  language: 'python',
  code: "result = {'result': input}",
  timeout: 30000,
  environment: 'python',
};

const NODE_DEFAULT_CONFIGS = {
  step: { description: '' },
  llm: { ...LLM_DEFAULTS },
  api: { ...API_DEFAULTS },
  code: { ...CODE_DEFAULTS },
  conditional: {
    condition: 'Boolean(input?.value)',
    trueLabel: 'Yes',
    falseLabel: 'No',
  },
  'human-input': {
    prompt: 'Please review and approve',
    inputType: 'approval',
    choices: '',
    showVariable: '',
    variableName: 'human_input',
  },
  'ai-agent': { ...LLM_DEFAULTS },
  'api-call': { ...API_DEFAULTS },
  'code-executor': { ...CODE_DEFAULTS },
  policy: {
    mode: 'design', policy_model_id: '', collection: 'policy_docs', output_to_context: true, output_variable: 'policy_model', run_query: false,
  },
  rag: {
    rag_mode: 'query',
    collection: 'documents',
    top_k: 5,
    similarity_threshold: 0,
    response_format: 'context_with_query',
    include_metadata: true,
    includeChatHistory: false,
    chatHistoryMaxMessages: 8,
  },
  'mcp-tool': {
    toolName: 'database_query',
    toolArguments: { query: 'SELECT * FROM table', parameters: [] },
    timeout: 30000,
    retries: 3,
    authentication: 'none',
    authToken: '',
  },
  database: {
    operation: 'query', connection: 'default', query: 'SELECT * FROM table', parameters: {},
  },
  webhook: {
    path: '/webhook', method: 'POST', authentication: 'none', responseFormat: 'json',
  },
  email: {
    to: '', subject: '', body: '', template: 'default', attachments: [],
  },
  sms: { to: '', message: '', provider: 'twilio' },
  form: {
    fields: [{
      name: 'name', label: 'Name', type: 'text', required: true, default: '',
    }],
    submitLabel: 'Submit',
    successMessage: 'Form submitted successfully!',
  },
  'execute-flow': { flowId: '', outputVariable: 'subflow_result', inputMapping: 'pass_through' },
  loop: {
    array: 'input.items', loopVariable: 'current_item', resultVariable: 'loop_results', maxIterations: 100, breakCondition: '',
  },
  transform: { inputSchema: {}, outputSchema: {}, transformation: 'return input;' },
  delay: { duration: 1000, unit: 'milliseconds' },
};

/** Palette / canvas icon per node type; every type in `NODE_METADATA` needs one. */
const NODE_ICONS = {
  start: PlayCircleOutlineOutlinedIcon,
  end: StopCircleOutlinedIcon,
  step: ViewModuleOutlinedIcon,
  llm: SmartToyOutlinedIcon,
  api: CloudOutlinedIcon,
  code: DataObjectOutlinedIcon,
  parallel: AccountTreeOutlinedIcon,
  join: JoinFullOutlinedIcon,
  aggregate: BarChartOutlinedIcon,
  'ai-agent': PsychologyOutlinedIcon,
  'api-call': HttpOutlinedIcon,
  calendar: CalendarMonthOutlinedIcon,
  chat: ForumOutlinedIcon,
  'code-executor': TerminalOutlinedIcon,
  conditional: CallSplitOutlinedIcon,
  connector: CableOutlinedIcon,
  'data-validation': FactCheckOutlinedIcon,
  database: StorageOutlinedIcon,
  db_delete: DeleteForeverOutlinedIcon,
  db_insert: PostAddOutlinedIcon,
  db_query: ManageSearchOutlinedIcon,
  db_update: EditNoteOutlinedIcon,
  debugger: BugReportOutlinedIcon,
  'decision-tree': SchemaOutlinedIcon,
  delay: TimerOutlinedIcon,
  email: EmailOutlinedIcon,
  'execute-flow': OpenInNewOutlinedIcon,
  'file-operations': FolderOpenOutlinedIcon,
  filter: FilterAltOutlinedIcon,
  form: AssignmentOutlinedIcon,
  group: GroupsOutlinedIcon,
  http_request: LanguageOutlinedIcon,
  'human-input': PersonOutlinedIcon,
  logger: ListAltOutlinedIcon,
  loop: LoopOutlinedIcon,
  'mcp-tool': PrecisionManufacturingOutlinedIcon,
  memory: MemoryOutlinedIcon,
  'memory-store': Inventory2OutlinedIcon,
  merge: MergeTypeOutlinedIcon,
  'message-queue': QueueOutlinedIcon,
  policy: GavelOutlinedIcon,
  rag: MenuBookOutlinedIcon,
  sms: SmsOutlinedIcon,
  'social-post': DynamicFeedOutlinedIcon,
  sort: SortOutlinedIcon,
  switch: ToggleOnOutlinedIcon,
  tool: BuildOutlinedIcon,
  transform: TransformOutlinedIcon,
  trigger: FlashOnOutlinedIcon,
  'try-catch': TryOutlinedIcon,
  'voice-call': PhoneInTalkOutlinedIcon,
  'web-crawler': TravelExploreOutlinedIcon,
  webhook: WebhookOutlinedIcon,
};

/** Catalog types without an entry in `NODE_ICONS` (they would render the generic extension icon). */
export function getLegacyNodeIconCoverageGaps() {
  return Object.keys(NODE_METADATA).filter((k) => !NODE_ICONS[k]);
}

function buildFullCatalog() {
  const out = {};
  for (const [type, meta] of Object.entries(NODE_METADATA)) {
    out[type] = {
      title: meta.title,
      subtitle: meta.subtitle,
      paletteGroup: meta.paletteGroup,
      colorKey: meta.colorKey,
      Icon: NODE_ICONS[type] || ExtensionOutlinedIcon,
      defaultLabel: meta.defaultLabel,
      defaultConfig: NODE_DEFAULT_CONFIGS[type] ? { ...NODE_DEFAULT_CONFIGS[type] } : {},
    };
  }
  return out;
}

export const STUDIO_V2_NODE_CATALOG = buildFullCatalog();

export function getStudioV2NodeMeta(type) {
  return STUDIO_V2_NODE_CATALOG[type] || STUDIO_V2_NODE_CATALOG.step;
}

export function getDefaultV2NodePayload(type) {
  const meta = getStudioV2NodeMeta(type);
  const id = `node_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
  const config = meta.defaultConfig && typeof meta.defaultConfig === 'object'
    ? { ...meta.defaultConfig }
    : {};
  return {
    id,
    type,
    label: meta.defaultLabel || type,
    config,
  };
}
